// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_b-2";
export var blackBorderOnHover = "_b-7";
export var cell = "_b-6";
export var cellContainer = "_b-3";
export var checked = "_b-8";
export var disabled = "_b-5";
export var featuredIconCellContainer = "_b-9";
export var featuredIconTextContainer = "_b-b";
export var featuredIconWrapper = "_b-a";
export var noBorder = "_b-c";
export var orangeSelectedRow = "_i-3";
export var overflowableText = "_b-0";
export var overflowableTextContainer = "_b-1";
export var row = "_a-0";
export var rowCheckboxCell = "_b-4";
export var selectableTable = "_i-2";